<template>
    <Header></Header>
    <Left></Left>
    <div class="containers">
        <ItemDetail :idx="state.idx" :refreshFlag="state.refreshFlag" @callback="state.refreshFlag = false"></ItemDetail>
        <section class="container">
            <div>
                <div class="area_title">
                    <p>홍보물품이력</p>
                    <div class="area_button">
                        <button type="button" class="" @click="showModal(null)">
                            <span>입/출고</span>
                        </button>

                        <button type="button" class="" @click="confirmRemove">
                            <span>일괄 삭제</span>
                        </button>
                    </div>
                </div>
                <div class="area_body">
                    <div class="area_section">
                        <div class="area_table">
                            <div class="area_table_head">
                                <div class="select-wrap">
                                    <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                        <option value="0">최근순</option>
                                        <option value="1">과거순</option>
                                    </select>
                                </div>

                                <div class="total_length">
                                    {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                                </div>
                            </div>

                            <div class="area_table_body">
                                <DataGrid
                                    :list="pageState.list"
                                    :columns="pageState.fields"
                                    :totalLength="pageState.length"
                                    :perPage="pageState.perPage"
                                    :cntPage="pageState.cntPage"
                                    :current-page="pageState.currentPage"
                                    :isLoading="pageState.isLoading"
                                    @onRowClick="fnRowClick"
                                    @onPaging="fnGetList"
                                    @onNextPage="fnGoPage"
                                    @onPrevPage="fnGoPage"
                                    @onFirstPage="fnGoPage"
                                    @onLastPage="fnGoPage"
                                    @allClick="selectAll"
                                ></DataGrid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <ItemHistoryAdd v-if="state.isShowAddModal" :data="state.data" @callback="historyCallback" @close="state.isShowAddModal = false"></ItemHistoryAdd>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        ItemDetail,
        useRoute,
        ItemHistoryAdd,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, ItemDetail, ItemHistoryAdd },
        setup() {
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 30);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "" as string,
                searchText1: "" as string,
                dept: 0 as number,
                order: 0 as number,

                isShowAddModal: false as boolean,
                idx: 0 as number,
                refreshFlag: false as boolean,
                data: {} as any,

                idxList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const searchCondition = [
                { key: "type", name: "세부항목" },
                { key: "title", name: "제목" },
                { key: "writer", name: "작성자" },
                { key: "team", name: "작성팀" },
            ];

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    {
                        key: "checkbox",
                        label: "",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return `<div class="checkbox_wrap">
                                <label for="checkbox${row.idx}">
                                    <input type="checkbox" id="checkbox${row.idx}" ${row.checked === true ? "checked" : ""} />
                                    <em></em>
                                    
                                </label>
                            </div>`;
                        },
                    },
                    { key: "", label: "No.", class: "text-center" },
                    {
                        key: "createDate",
                        label: "등록일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.createDate, ".", true);
                        },
                    },
                    {
                        key: "type",
                        label: "입/출고",
                        class: "text-center",
                        render: (row: any) => {
                            return row.type === 1 ? "입고" : "출고";
                        },
                    },
                    {
                        key: "cnt",
                        label: "수량",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.numberFormat(row.cnt);
                        },
                    },

                    {
                        key: "place",
                        label: "위치",
                        class: "text-center",
                        render: (row: any) => {
                            return row.type === 1 ? row.place : "";
                        },
                    },
                    {
                        key: "location",
                        label: "사용처",
                        class: "text-center",
                        render: (row: any) => {
                            return row.type === 2 ? row.location : "";
                        },
                    },
                    { key: "writer", label: "작성자", class: "text-center" },
                    {
                        key: "btnModal",
                        label: "수정",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return "<img src = 'img/modify_icon.png' style = 'width:24px; height:auto;cursor:pointer'>";
                        },
                    },
                ],
            });

            onMounted(() => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
                state.idx = Number(route.params.id);
                fnGetList(1);
            });

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType1 = "";
                state.searchText1 = "";
                state.dept = 0;
                state.order = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.ReqParam = {
                    page: page,
                    size: pageState.perPage,
                    searchType: state.searchType1,
                    searchText: state.searchText1,
                    order: state.order,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                let res: types.ResPaging = await apiService.item.listForHistory(state.idx, param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.list.forEach((item: any) => {
                        item.checked = false;
                    });
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const selectAll = (checked: boolean) => {
                pageState.list.forEach((item: any) => {
                    item.checked = checked;
                });

                if (checked) {
                    state.idxList = [];
                    pageState.list.forEach((item: any) => {
                        if (item.checked) state.idxList.push(item.idx);
                    });
                } else {
                    state.idxList = [];
                }
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "btnModal") showModal(row);
                else if (col.key === "checkbox") {
                    if (row.checked) {
                        row.checked = false;
                        state.idxList.splice(state.idxList.indexOf(row.idx), 1);
                    } else {
                        row.checked = true;
                        if (state.idxList.indexOf(row.idx) === -1) state.idxList.push(row.idx);
                    }
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const showModal = (data: any) => {
                state.data = data;
                state.isShowAddModal = true;
            };

            const closeModal = () => {
                if (state.modalTab === -1) {
                } else {
                }
                state.isShowModal = false;
            };

            const confirmRemove = () => {
                if (state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제할 이력을 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 1;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    removeItem();
                }
            };

            const historyCallback = async (param: any) => {
                if (param.cnt <= 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "수량을 확인해주세요.";
                    state.isShowModal = true;
                    return;
                }
                if (param.idx > 0) {
                    const param_for_modify: types.item.ReqItemHistoryForModify = {
                        idx: param.idx,
                        type: param.type,
                        cnt: param.cnt,
                        place: param.place,
                        location: param.location,
                    };
                    const res = await apiService.item.modifyForHistory(state.idx, param_for_modify);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "저장이 완료되었습니다.";
                        state.isShowModal = true;
                        state.isShowAddModal = false;
                        fnGetList(pageState.currentPage);
                        state.refreshFlag = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    const param_for_add: types.item.ReqItemHistory = {
                        type: param.type,
                        cnt: param.cnt,
                        place: param.place,
                        location: param.location,
                    };
                    const res = await apiService.item.addForHistory(state.idx, param_for_add);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "저장이 완료되었습니다.";
                        state.isShowModal = true;
                        state.isShowAddModal = false;
                        fnGetList(pageState.currentPage);
                        state.refreshFlag = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const removeItem = async () => {
                const res = await apiService.item.removeForHistoryForMultiple(state.idx, state.idxList);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    fnGetList(pageState.currentPage);
                    state.refreshFlag = true;

                    state.idxList = [];
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                selectAll,
                CommonUtils,
                setDateToToday,
                searchCondition,
                stateList,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                historyCallback,
                confirmRemove,
            };
        },
    };
</script>
<style scoped></style>
